import { NavLink } from 'react-router-dom';

import { Breadcrumb } from '@indicia/component-library';

import useBreadcrumbs from '../../hooks/use-breadcrumbs';
import Icon from '../button/enums/Icon';
import IconRender from '../icon/IconRender';

import './GLTBreadcrumb.scss';

type GLTBreadcrumbProps = {
  className?: string;
  visible?: boolean;
};

const GLTBreadcrumb = ({ className = '', visible = true }: GLTBreadcrumbProps) => {
  const breadcrumbItems = useBreadcrumbs();

  return (
    <div className={className}>
      {visible && (
        <Breadcrumb
          items={breadcrumbItems.map((item) => (item.to ? <NavLink to={item.to}>{item.label}</NavLink> : item.label))}
          separator={
            <IconRender
              icon={Icon.chevronRight}
              width="16"
              height="16"
              color="var(--zk-blue)"
            />
          }
          hasBackground={false}
        />
      )}
    </div>
  );
};

export default GLTBreadcrumb;
